import { DEFAULT_COLORS } from 'oskari-ui/theme';
var CSS_CLASS_PREFIX_FONT = 'oskari-theme-font-';
export var getDefaultMapTheme = function getDefaultMapTheme() {
  return {
    // For buttons on map
    navigation: {
      roundness: 100,
      opacity: 0.8,
      color: {
        primary: DEFAULT_COLORS.DARK_BUTTON_BG,
        accent: DEFAULT_COLORS.ACCENT,
        text: '#ffffff'
      }
    },
    // /For buttons on map ^
    // --------------
    // For popup headers opened by map:
    color: {
      header: {
        // #3c3c3c -> rgb(60,60,60)
        bg: '#3c3c3c'
      }
      // accent should be inherited from global theme accent if not configured
      // accent: '#ffd400'
    }
    // /For popup headers opened by map ^
  };
};

// set font class for map module/map controls. Windows/popups will get it through theme
export var setFont = function setFont(mapEl) {
  var requestedFont = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'arial';
  // on unit tests the mapEl might be undefined
  var classlist = mapEl === null || mapEl === void 0 ? void 0 : mapEl.classList;
  if (!classlist) {
    return;
  }
  var newFontClass = CSS_CLASS_PREFIX_FONT + (requestedFont || 'arial');
  classlist.forEach(function (clazz) {
    if (clazz !== newFontClass && clazz.startsWith(CSS_CLASS_PREFIX_FONT)) {
      classlist.remove(clazz);
    }
  });
  classlist.add(newFontClass);
};